const Cooks = () => import("./views/Cooks.vue");
const CookEdit = () => import("./views/CookEdit.vue");

const route = "/cooks";

export default [
  {
    path: route,
    name: "cooks.list",
    component: Cooks,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "cooks.create",
    component: CookEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:cookId/edit`,
    name: "cooks.edit",
    component: CookEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
